import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <FaqSection />
        <CommentsSection />
        <RankingSection />
        <AboutSection />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}